var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_8627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9879 25.0001L24.9941 24.9991V15.8303C24.9941 11.3449 24.0285 7.88967 18.7848 7.88967C16.2639 7.88967 14.5723 9.27301 13.8816 10.5845H13.8087V8.30842H8.83685V24.9991H14.0139V16.7345C14.0139 14.5584 14.4264 12.4543 17.1212 12.4543C19.7764 12.4543 19.816 14.9376 19.816 16.874V25.0001H24.9879ZM0.406641 8.30947H5.58997V25.0001H0.406641V8.30947ZM2.99622 9.15527e-05C1.33893 9.15527e-05 -0.00585938 1.34488 -0.00585938 3.00217C-0.00585938 4.65947 1.33893 6.03238 2.99622 6.03238C4.65352 6.03238 5.99831 4.65947 5.99831 3.00217C5.99776 2.20614 5.68129 1.44287 5.11841 0.879991C4.55553 0.317111 3.79226 0.000643395 2.99622 9.15527e-05Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_8627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinIcon);
export default __webpack_public_path__ + "static/media/linkdin-icon.9eb4d6dca80aa15ea24743d29aa63adb.svg";
export { ForwardRef as ReactComponent };